import { render } from "./vehicleDetail.vue?vue&type=template&id=75524c04&scoped=true&lang=true"
import script from "./vehicleDetail.vue?vue&type=script&lang=js"
export * from "./vehicleDetail.vue?vue&type=script&lang=js"

import "./vehicleDetail.vue?vue&type=style&index=0&id=75524c04&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75524c04"]])

export default __exports__